import { ChangeDetectionStrategy,Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose,MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField, MatHint,MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

@Component({
    templateUrl: './add-locale-dialog.component.html',
    styleUrls: ['./add-locale-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, MatDialogContent, FormsModule, MatFormField, MatLabel, MatInput, MatHint, MatDialogActions, MatButton, MatDialogClose]
})
export class AddLocaleDialogComponent {
    culture: string;
}
